import { cn } from '@/lib/utils';
import { Info } from 'lucide-react';

interface InputInfoProps {
	text?: string;
	className?: string;
}

const InputInfo = ({
	className,
	text = 'dado obrigatório',
}: InputInfoProps) => {
	return (
		<div className={cn('flex items-center gap-1', className && className)}>
			<div>
				<Info className="size-3  text-zinc-400" />
			</div>
			<span className="text-xs text-zinc-400 ">{text}</span>
		</div>
	);
};

export { InputInfo };
